import { Program } from '@edassist/api';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProgramUtilityService {
	static isProgramFeatureEnabled(
		program: Program,
		featureCode: string
	): boolean {
		return !!program?.programFeaturesReferences.find(
			(programFeatureReference) =>
				programFeatureReference.programFeature.code === featureCode
		);
	}

	static isAnyProgramFeatureEnabled(
		programs: Array<Program>,
		featureCode: string
	): boolean {
		return !!programs?.find((program) =>
			ProgramUtilityService.isProgramFeatureEnabled(program, featureCode)
		);
	}
}
